<!--  <p>recover-link works!</p>  -->
<p-toast key="tst" [style]="{marginTop: '70px'}"></p-toast>
<!-- RECOVER CARD -->
<section class="recoverLink">


    <form class="card p-fluid p-col-12 p-md-6  ui-g ui-fluid top-buffer recoverLinkFrom" [formGroup]="recoverLinkFrom">


        <div class="p-d-flex p-flex-row p-col-4" *ngIf="device != '2'">
            <div class="ui-xl-2 ui-lg-3 ui-md-3 ui-g-3">
                <button pButton class="button-back" pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left"
                    class="p-button-warning p-mr-2" (click)="goBack()"></button>
            </div>
        </div>

        <h4 class="recoverLinkFrom__title" *ngIf="device != '2'">{{lbl_link}}</h4><br />
        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-google"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="1" formControlName="currentEmail" type="email" aria-describedby="current-help"
                            pInputText />
                        <label htmlFor="currentEmailInput">{{lbl_email}}</label>
                    </span>
                </div>


            </div>
        </fieldset><br />

        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-id-card"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="2" id="currentCertifiedInput" formControlName="currentCertified"
                            aria-describedby="current-help" pInputText />
                        <label htmlFor="currentCertifiedInput">{{lbl_certificate}}</label>
                    </span>
                </div>
            </div>
        </fieldset><br />

        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="3" id="currentIdGuideInput" formControlName="currentIdGuide"
                            aria-describedby="current-help" pInputText />
                        <label htmlFor="currentIdGuideInput">{{lbl_guide_id}}</label>
                    </span>
                </div>

            </div>
        </fieldset><br />

        <!-- INPUT BUTTON -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <button tabIndex="4" pButton pRipple type="button" icon="pi pi-check" label="{{lbl_request}} Link"
                    class="p-button-raised p-button-success" (keyup.enter)="confirmRecoverLink($event)"
                    (click)="confirmRecoverLink($event)"></button>
            </div>
        </fieldset><br />
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">

            <p *ngIf="guideName">Información:</p>
            <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                <div class="subTitle p-col-11">
                    <div class="p-inputgroup">
                        <span *ngIf="guideName" class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
                        <input id="guideName" *ngIf="guideName" type="text" value="{{guideName}}" disabled="true"
                            pInputText placeholder="Username">
                    </div>
                </div>
            </div>
            <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                <div class="subTitle p-col-11">
                    <div class="p-inputgroup">
                        <span *ngIf="linkResulted" class="p-inputgroup-addon"><i class="pi pi-globe"></i></span>
                        <input id="linkResulted" *ngIf="linkResulted" type="text" value="{{linkResulted}}"
                            disabled="true" pInputText placeholder="Username">
                    </div>
                </div>
                <div class="subTitle p-col-1">
                    <button *ngIf="linkResulted" pTooltip="Copy to clipboard" pButton pRipple type="button"
                        icon="pi pi-copy" class="p-button-raised p-button-success"
                        (click)="copyToClipBoard(linkResulted)"></button>
                </div>
            </div>
        </fieldset><br />
    </form>
</section>